// src/components/DualButton.js
import React from "react";
import CustomWorkoutButton from "./CustomWorkoutButton";
import ContactButton from "./ContactButton";

const DualButton = ({ recipient }) => {
  return (
    <div style={{ display: "flex", gap: "1rem", justifyContent: "center" }}>
      {/* <CustomWorkoutButton recipient={recipient} /> */}
      <ContactButton recipient={recipient} />
    </div>
  );
};

export default DualButton;
